<template>
    <div class="login-form__external-login">
        <span>{{ trans("Log in using") }}:</span>
        <div class="flex-box">
            <a v-if="$store.state.settings.site_id === 3 " href="/login/vk"
               class="login-form__external-login__element login-form__link">
                            <span class="social-network-icon">
                                <img class="footer__network-img" src="https://batnorton.com/img/svg/ic-vk.svg"
                                     alt="icon vkontakte">
                            </span>
            </a>

            <a v-if="$store.state.settings.site_id === 1 " href="/login/yandex"
               class="login-form__external-login__element login-form__link">
                            <span class="social-network-icon">
                                <img class="footer__network-img" src="https://batnorton.com/img/icons/yandex.webp"
                                     alt="icon yandex">
                            </span>
            </a>

            <a v-if="$store.state.settings.site_id === 2 " href="/login/facebook" class="login-form__external-login__element login-form__link">
                            <span class="social-network-icon">
                                <img class="footer__network-img" src="https://batnorton.com/img/icons/facebook.png" alt="icon facebook">
                            </span>
            </a>

            <a v-if="$store.state.settings.site_id !== 1" href="/login/google"
               class="login-form__external-login__element login-form__link">
                            <span class="social-network-icon">
                                <img class="footer__network-img" src="https://batnorton.com/img/icons/google.png"
                                     alt="icon google">
                            </span>
            </a>

        </div>

    </div>
</template>

<script>
export default {
    name: "social-lite",
}
</script>

<style scoped>

</style>
